import { Suspense, useContext, useEffect, useState } from 'react';
import { SharedContext } from './StateManagement/Reducers/SharedReducer';
import { Loader } from './Components/Loader/Loader';
import Header from './Components/Header/Header';
import AppRoutes from './Routes/Routes';
import { Box, useMediaQuery } from '@mui/material';
import Sidenav from './Components/SideNav/Sidenav';
import { SnackbarAlert } from './Components/Snackbar/SnackbarAlert';
import { ActiviateHttpServices } from './Services/BaseAPI';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { loginRequest } from './Helpers/AuthHelper';
import { GetAccountManagerByEmail } from './Services/Shared';
import NoAccountManagerPermsisonRoute from './Components/NoAccountManagerPermssion/NoAccountManagerPermssion';
import { initialAccountManagerDetailsState } from './Store/Shared';


function App() {

  const { SetOpenSidenav, SetAccountManagerDetails, state: { miniSidenav } } = useContext(SharedContext);
  const mdScreen = useMediaQuery('(max-width:1200px)');

  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [token, setToken] = useState<string | null>(null);


  const getToken = async () => {
    const request = {
      ...loginRequest,
      account: accounts[0]
    }
    let AzureInstance = await instance.acquireTokenSilent(request).catch((erorr) => instance.loginRedirect());
    ActiviateHttpServices(AzureInstance);
    await getAccountManagerByEmailData(accounts[0].username);
    setToken(AzureInstance!.accessToken);
  }

  useEffect(() => {
    if (isAuthenticated) {
      getToken();
    }
  }, [isAuthenticated, instance, accounts])

  useEffect(() => {
    SetOpenSidenav(!mdScreen);
  }, [mdScreen])

  const getAccountManagerByEmailData = async (email: string) => {
    await GetAccountManagerByEmail(email).then((response) => {
      SetAccountManagerDetails(response.data.result)
    }).catch(() => {
      SetAccountManagerDetails(initialAccountManagerDetailsState)
    })
  }

  return (
    <Suspense fallback={<Loader isActive={true} isAbsolute={true} isWithoutText={true} />}>
      <Sidenav />
      <Box style={{ marginLeft: mdScreen ? "0rem" : miniSidenav ? "6rem" : "17.125rem", padding: "24px" }}>
        <Header />
        {token &&
          <>
            <AppRoutes />
          </>
        }
      </Box>
      <SnackbarAlert />
    </Suspense>
  );
}

export default App;
